import { SUPPORT_MAPS } from '../../constants'
import i18n from '../../resources/index'

const state = {
  //平台设置数据
  meunSettingData: null,
  mapSettingData: null,
  generalSettingData: null,
  MGSettingData: null,
  videoSettingData: null,
  bigScreenLock: true,
  styleSettingData: null,
  realtimeSettingData: null,

  handlerSettingData: null,

  // 自定义时区（平台设置 → 自定义时区）
  // mode: 'auto' = 跟随浏览器，'fixed' = 用 offsetMinutes
  // offsetMinutes: 正东负西，与 -getTimezoneOffset() 同号
  timezoneSettingData: { mode: 'auto', offsetMinutes: 0 },

  // 实时监控状态选择列表
  monitorItemsIconStautsCheck: [
    { disabled: true, checked: true, icon: 'all_check', text: 'checkAll' },
    { disabled: false, checked: false, icon: 'nolocate', text: 'nolocate' },
    { disabled: false, checked: false, icon: 'off_alarm', text: 'off_alarm' },
    {
      disabled: false,
      checked: false,
      icon: 'off_nolocate',
      text: 'off_nolocate',
    },
    { disabled: false, checked: false, icon: 'offline', text: 'offline' },
    {
      disabled: false,
      checked: false,
      icon: 'on_nolocate',
      text: 'on_nolocate',
    },
    {
      disabled: false,
      checked: false,
      icon: 'on_p_accoff_alarm',
      text: 'on_p_accoff_alarm',
    },
    {
      disabled: false,
      checked: false,
      icon: 'on_p_accoff',
      text: 'on_p_accoff',
    },
    { disabled: false, checked: false, icon: 'on_p_accon', text: 'on_p_accon' },
    {
      disabled: false,
      checked: false,
      icon: 'on_p_accon_alarm',
      text: 'on_p_accon_alarm',
    },
    {
      disabled: false,
      checked: false,
      icon: 'on_p_idling',
      text: 'on_p_idling',
    },
    { disabled: false, checked: false, icon: 'on_t_alarm', text: 'on_t_alarm' },
    {
      disabled: false,
      checked: false,
      icon: 'on_t_idling',
      text: 'on_t_idling',
    },
    { disabled: false, checked: false, icon: 'online', text: 'online' },
  ],

  //通用设置
  RealtimeSettingDefault: {
    dataRefreshTimeSelected: 20, //数据刷新时间(秒)
    dataRefreshTimeList: [10, 20, 30, 60], // 数据刷新时间列表

    labelExtend: [
      { label: 'gpsTime', checked: false, name: 'gpsTime' },
      { label: 'speed', checked: false, name: 'speed' },
      { label: 'alarm', checked: true, name: 'alarm' },
      // { label: "油耗L", checked: false },
      // { label: "行停时长", checked: false },
      // { label: "详细地址", checked: false },
    ],
    isFollowMap: false, //是否跟随地图
    isCluster: true, //是否开启聚合功能
    isTest: false,
    gpsInvalidBehavior: 'showLastGps', // GPS无效时的行为：showLastGps 显示最后GPS位置, showOther 显示其他位置
    lbsPriority: 'gsm', // LBS优先定位方式：gsm GSM基站优先, wifi Wifi定位优先, wifiOnly 仅使用Wifi
    baseStationDisplay: 'show', // 基站定位显示：show 显示, hide 不显示
  },
  //平台设置初始数据

  //菜单设置,type:1是navi侧边栏,2是右上角菜单栏item
  //todo:1是router跳转,2是打开对应功能
  meunSettingDefault: [
    {
      title: i18n.t('title.dashboard'),
      icon: 'mdi-view-dashboard',
      name: 'dashboard',
      resKey: 'dashboard.title',
      type: 1,
      selected: false,
      checked: true,
      access_code: 1000003,
      todo: 1,
    },

    {
      title: i18n.t('title.realTimeMonitor'),
      icon: 'mdi-map-marker-radius',
      name: 'realTimeMonitor',
      selected: false,
      type: 1,
      checked: true,
      access_code: 1000004,
      todo: 1,
    },
    {
      title: i18n.t('title.videoMonitor'),
      icon: 'mdi-google-lens',
      name: 'videoMonitor',
      svg: 'videomonitor',
      isSvg: true,
      selected: false,
      type: 1,
      checked: true,
      access_code: 1000013,
      todo: 1,
    },
    {
      title: i18n.t('title.trackPlayback'),
      icon: 'mdi-map-marker-path',

      name: 'trackPlayback',
      svg: 'trackplayback',
      isSvg: true,
      selected: false,
      type: 1,
      checked: true,
      access_code: 1000005,
      todo: 1,
    },
    {
      title: i18n.t('title.multiScreenTracks'),
      icon: 'mdi-monitor-multiple',
      name: 'multiScreenTracks',
      selected: false,
      type: 1,
      checked: true,
      access_code: 1000015,
      todo: 1,
    },
    {
      title: i18n.t('title.videoPlayback'),
      icon: 'mdi-movie-play-outline',
      name: 'videoPlayback',
      svg: 'videoplayback',
      isSvg: true,
      selected: false,
      type: 1,
      checked: true,
      access_code: 1000014,
      todo: 1,
    },
    {
      title: i18n.t('title.geoFence'),
      icon: 'mdi-fence',
      name: 'geoFence',
      selected: false,
      type: 1,
      checked: true,
      access_code: 1000010,
      todo: 1,
    },

    {
      title: i18n.t('title.statisticalReport'),
      icon: 'mdi-chart-bar',
      name: 'statisticalReport',
      selected: false,
      type: 1,
      checked: true,
      access_code: 1000006,
      todo: 1,
    },
    {
      title: i18n.t('title.bigtest'),
      icon: 'mdi-monitor-dashboard',
      name: 'bigtest',
      type: 1,
      selected: false,
      checked: true,
      access_code: 1000902,
      todo: 2,
    },
    {
      title: i18n.t('title.management'),
      icon: 'mdi-clipboard-list',
      type: 1,
      sub: [
        {
          title: i18n.t('title.accountManage'),
          name: 'accountManage',
          isLeaf: true,
          selected: false,
          type: 1,
          checked: true,
          icon: 'mdi-account',
          access_code: 1000701,
          todo: 1,
        },
        {
          title: i18n.t('title.vehicleSetting'),
          name: 'vehicleSetting',
          isLeaf: true,
          type: 1,
          selected: false,
          checked: true,
          icon: 'mdi-car',
          access_code: 1000703,
          todo: 1,
        },
        {
          title: i18n.t('title.infoManagement'),
          name: 'infoManagement',
          isLeaf: true,
          selected: false,
          type: 1,
          checked: true,
          icon: 'mdi-information',
          access_code: 1000702,
          todo: 1,
        },
        {
          title: i18n.t('title.driverManagement'),
          name: 'driverManagement',
          isLeaf: true,
          selected: false,
          type: 1,
          checked: true,
          icon: 'mdi-card-account-details',
          access_code: 1000704,
          todo: 1,
        },
        {
          title: i18n.t('title.pOIManagement'),
          name: 'pOIManagement',
          isLeaf: true,
          selected: false,
          checked: true,
          type: 1,
          icon: 'mdi-map-marker',
          access_code: 1000705,
          todo: 1,
        },
        {
          title: i18n.t('title.otaManage'),
          name: 'otaManage',
          isLeaf: true,
          selected: false,
          checked: true,
          type: 1,
          icon: 'mdi-arrow-up-bold-circle',
          access_code: 1000706,
          todo: 1,
        },
        {
          title: i18n.t('title.ruleManagement'),
          name: 'ruleManagement',
          isLeaf: true,
          type: 1,
          selected: false,
          checked: true,
          icon: 'mdi-factory',
          access_code: 1000707,
          todo: 1,
        },
        {
          title: i18n.t('title.maintenanceManage'),
          name: 'maintenanceManage',
          icon: 'mdi-car-wrench',
          selected: false,
          isLeaf: true,
          checked: true,
          type: 1,
          access_code: 1000901,
          todo: 1,
        },
        {
          title: i18n.t('title.insuranceManage'),
          name: 'insuranceManage',
          icon: 'mdi-security',
          selected: false,
          checked: true,
          isLeaf: true,
          type: 1,
          access_code: 1000903,
          todo: 1,
        },
        {
          title: i18n.t('title.certificateManage'),
          name: 'certificateManage',
          icon: 'mdi-file-document',
          selected: false,
          isLeaf: true,
          checked: true,
          type: 1,
          access_code: 1000904,
          todo: 1,
        },
        {
          title: i18n.t('title.maintenanceCostSummary'),
          name: 'maintenanceCostSummary',
          icon: 'mdi-chart-bar',
          selected: false,
          isLeaf: true,
          checked: true,
          type: 1,
          access_code: 1000906,
          todo: 1,
        },
        {
          title: i18n.t('title.maintenanceCostManage'),
          name: 'maintenanceCostManage',
          icon: 'mdi-cash-marker',
          selected: false,
          isLeaf: true,
          checked: true,
          type: 1,
          access_code: 1000905,
          todo: 1,
        },
      ],
      selected: false,
      checked: true,
      name: 'management',
      access_code: 1000007,
      todo: 1,
    },
    // {
    //   title: '更多',
    //   icon: 'mdi-chart-bar',
    //   name: 'more',
    //   selected: false,
    //   checked: true,
    //   type: 3,
    //   access_code: 1000008,
    // },
    {
      title: i18n.t('title.systemCentr'),
      icon: 'mdi-chart-bar',
      name: 'systemCentr',
      selected: false,
      checked: true,
      type: 2,
      access_code: 1000009,
      todo: 1,
      sub: [
        {
          title: i18n.t('title.platformSetting'),
          icon: 'mdi-cogs',
          selected: false,
          isLeaf: true,
          checked: true,
          disabled: true,
          type: 2,
          name: 'platformSetting',
          access_code: 10000901,
          todo: 2,
        },
        // {
        //   title: "智慧大屏",
        //   icon: "mdi-monitor-dashboard",
        //   selected: false,
        //   isLeaf: true,
        //   checked: true,
        //   type: 2,
        //   name: "bigtest",
        //   access_code: 1000902,

        // },
        {
          title: i18n.t('title.autorenew'),
          icon: 'mdi-autorenew',
          selected: false,
          isLeaf: true,
          checked: true,
          type: 2,
          name: 'autorenew',
          access_code: 10000903,
        },
        {
          title: i18n.t('title.userSetting'),
          icon: 'mdi-account-edit',
          selected: false,
          checked: true,
          type: 2,
          isLeaf: true,
          name: 'userSetting',
          access_code: 10000904,
          todo: 2,
        },

        {
          title: i18n.t('title.help'),
          icon: 'mdi-help-box-multiple-outline',
          selected: false,
          checked: true,
          isLeaf: true,
          type: 2,
          name: 'help',
          access_code: 1000905,
        },

        {
          title: i18n.t('title.feedback'),
          icon: 'mdi-package',
          selected: false,
          checked: true,
          isLeaf: true,
          type: 2,
          name: 'feedback',
          access_code: 1000910,
        },

        // {
        //   title: "规则管理",
        //   icon: "mdi-help-box-multiple-outline",
        //   selected: false,
        //   name: "rulepage",
        // },

        {
          title: i18n.t('title.systemCenter'),
          icon: 'mdi-tune-variant',
          selected: false,
          checked: true,
          type: 2,
          name: 'systemCenter',
          access_code: 1000906,
          todo: 1,
          sub: [
            {
              title: i18n.t('title.logQuery'),
              icon: 'mdi-clipboard-text-search-outline',
              name: 'logQuery',
              isLeaf: true,
              checked: true,
              type: 2,
              selected: false,
              access_code: 100090601,
              todo: 1,
            },
            {
              title: i18n.t('title.onlineUser'),
              icon: 'mdi-account-settings-outline',
              name: 'onlineUser',
              isLeaf: true,
              checked: true,
              type: 2,
              selected: false,
              access_code: 100090602,
            },
            {
              title: i18n.t('title.flowAnalysis'),
              icon: 'mdi-swap-horizontal',
              name: 'flowAnalysis',
              isLeaf: true,
              checked: true,
              type: 2,
              selected: false,
              access_code: 100090603,
            },

            {
              title: i18n.t('platform.mgSetting.Arrearsinformation'),
              icon: 'mdi-currency-usd',
              name: 'platform.mgSetting.Arrearsinformation',
              isLeaf: true,
              checked: true,
              type: 2,
              selected: false,
              access_code: 100090604,
              needTrans: true,
            },
            {
              title: i18n.t('topbar.todo'),
              icon: 'mdi-format-list-checks',
              name: 'topbar.todo',
              isLeaf: true,
              checked: true,
              type: 2,
              selected: false,
              access_code: 100090605,
              needTrans: true,
            },
            {
              title: i18n.t('platform.mgSetting.announcement'),
              icon: 'mdi-bulletin-board',
              name: 'platform.mgSetting.announcement',
              isLeaf: true,
              checked: true,
              type: 2,
              selected: false,
              access_code: 100090606,
              needTrans: true,
            },
          ],
        },

        {
          title: i18n.t('title.about'),
          icon: 'mdi-information-outline',
          selected: false,
          isLeaf: true,
          type: 2,
          checked: true,
          name: 'about',
          disabled: true,
          access_code: 1000012,
        },

        // {
        //   title: i18n.t('title.cleanVuex'),
        //   icon: "mdi-notification-clear-all",
        //   selected: false,
        //   isLeaf: true,
        //   type: 2,
        //   checked: true,
        //   name: "cleanVuex",
        //   disabled: true,
        //   access_code: 1000908,
        // },
        {
          title: i18n.t('title.exit'),
          icon: 'mdi-exit-to-app',
          selected: false,
          isLeaf: true,
          type: 2,
          checked: true,
          name: 'exit',
          disabled: true,
          access_code: 1000907,
        },
      ],
    },
  ],

  //通用设置
  MGSettingDefault: {
    loginHomeSelected: 1000004, //登际页、修改成实时追踪
    loginHomeList: [], //登陆列表
    noWifiOrLanEnabled: false, //无WiFi或LAN提示，默认关闭
    backlog: false, //待办事项
    arrearageMeg: false, //欠费信息
    arrearageMegRemiadDay: null,
    notice: false, //公告
    alarmSoundEnabled: false, //报警声音
    dataRefreshTimeSelected: 20, //数据刷新时间(秒)
    dataRefreshTimeList: [10, 20, 30, 60], // 数据刷新时间列表
    mileageUnitSelected: 1, //里程单位
    mileageUnitList: [
      { title: 'platform.genal.kilometer', value: 1 },
      // { title: i18n.t('platform.genal.mile'), value: 2 },
    ],
    speedUnitSelected: 1, //速度单位
    speedUnitList: [
      { title: 'platform.genal.kilometerHour', value: 1 },
      // { title: i18n.t('platform.genal.mileHour'), value: 2 },
    ],
    dateFormatSelected: 'yyyy-dd--MM', //日期格式
    dateFormatList: ['yyyy-dd--MM'],
    TimeFormatSelected: 'HH:mm:ss', //时间格式
    TimeFormatList: ['HH:mm:ss'],
  },
  // 视频设置
  videoSettingDefault: {
    S: '0',
    times: [5, 10, 30, 60, '0'],
    pushStreamType: 0,
    pushStreamTypes: [
      { title: 'platform.setupVideo.pushBareStream', value: 0 },
      { title: 'platform.setupVideo.pushRTMP', value: 1 },
    ],
  },
  // 地图设置
  mapSettingDefault: {
    selected: null,
    paltCheckboxInfo: [
      {
        name: 'google_street',
        value: 'google_street',
        text: '谷歌地图',
        selected: false,
        multiSelected: true,
      },
      {
        name: 'google_highbird',
        value: 'google_highbird',
        text: '谷歌鸟瞰图',
        selected: false,
        multiSelected: false,
      },
      {
        name: 'open_street',
        value: 'open_street',
        text: 'open地图',
        selected: false,
        multiSelected: false,
      },
      {
        name: 'google_satellite',
        value: 'google_satellite',
        text: '谷歌卫星',
        selected: false,
        multiSelected: false,
      },
      {
        name: 'tiandi_street',
        value: 'tiandi_street',
        text: '天地图',
        selected: false,
        multiSelected: true,
      },
      {
        name: 'tiandi_satellite',
        value: 'tiandi_satellite',
        text: '天地图卫星',
        selected: false,
        multiSelected: false,
      },
      {
        name: 'gaode_street',
        value: 'gaode_street',
        text: '高德地图',
        selected: false,
        multiSelected: true,
      },
      {
        name: 'gaode_satellite',
        value: 'gaode_satellite',
        text: '高德卫星',
        selected: false,
        multiSelected: false,
      },
    ],
  },

  handlerSettingDefaultData: {
    expired: false,
    reminder: false,
    alarm: false,
  },

  // 自定义时区默认值：跟随浏览器，offsetMinutes 字段在 mode='auto' 下被忽略
  timezoneSettingDefault: { mode: 'auto', offsetMinutes: 0 },

  generalSettingDefaultData: {
    VehicleOnline: {
      onlineType: '1', //1为接收时间 0为gps时间
      onlineTime: 10, //
      onlineIridiumInterval: 4320, // Iridium设备在线间隔(分钟)，默认4320=72小时
      longOfflineTime: 1440, // 默认1440分钟(24小时)
      longOfflineTimeEnable: false,
      sleepOffline: false,
      positioningSpeedOffline: false,
      positioningSpeedBetween: {
        km: 15,
        min: 15,
      },
    },
    VehicleStop: {
      positioningSpeed: false,
      km: 15,
    },
    fuelConsumptionSetting: {
      fuelConsumption: true,
      L: 15,
      sensorPriority: true,
      ruleFirst: true,
    },
    muenType: {
      meunSelected: 'left',
    },

    themeColor: '#282F44',
  },

  styleSettingDefault: {
    selected: '1',
  },

  // 添加设备统计状态对象
  deviceStatistics: {
    totalDevices: 0,
    onlineDevices: 0,
    alarmDevices: 0,
    longOfflineDevices: 0, // 新增长时间离线设备数量
    lastUpdate: null,
    isLoading: false,
  },

  menuTagList: [
    {
      title: '智慧大屏',
      icon: 'mdi-monitor-dashboard',
      id: 'bigtest',
      name: 'title.bigtest',
      selected: true,
      isShow: true,
      access_code: 1000902,
    },
    {
      title: 'Dashboard',
      id: 'dashboard',
      name: 'title.dashboard',
      isShow: true,
      icon: 'mdi-view-dashboard',
      access_code: 1000003,
      selected: true,
    },
    {
      title: '实时监控',
      id: 'realTimeMonitor',
      name: 'home.realTimeMonitor',
      isShow: true,
      icon: 'mdi-map-marker-radius',
      access_code: 1000004,
      selected: true,
    },
    {
      title: '实时视频',
      id: 'videoMonitor',
      name: 'title.videoMonitor',
      isShow: true,
      icon: 'mdi-google-lens',
      access_code: 1000013,
      selected: true,
      svg: 'videomonitor',
      isSvg: true,
    },
    {
      title: '轨迹回放',
      id: 'trackPlayback',
      name: 'home.trackPlayback',
      isShow: true,
      icon: 'mdi-map-marker-path',
      access_code: 1000005,
      selected: true,
      svg: 'trackplayback',
      isSvg: true,
    },
    {
      title: '多屏轨迹',
      id: 'multiScreenTracks',
      name: 'title.multiScreenTracks',
      isShow: true,
      icon: 'mdi-monitor-multiple',
      access_code: 1000015,
      selected: true,
    },
    {
      title: '录像回放',
      id: 'videoPlayback',
      name: 'title.videoPlayback',
      isShow: true,
      icon: 'mdi-movie-play-outline',
      access_code: 1000014,
      selected: true,
      svg: 'videoplayback',
      isSvg: true,
    },
    // {
    //   title: '统计报表',
    //   id: 'statisticalReport',
    //   name: 'home.statisticalReport',
    //   isShow: true,
    //   icon: 'mdi-chart-bar',
    //   access_code: 1000006,
    //   selected: false,
    // },

    // {
    //   title: '电子围栏',
    //   id: 'geoFence',

    //   name: 'title.geoFence',
    //   isShow: true,
    //   icon: 'mdi-fence',
    //   access_code: 1000010,
    //   selected: false,
    // },
    {
      title: '帐号管理',
      id: 'accountManage',
      name: 'title.accountManage',
      isShow: true,
      icon: 'mdi-account',
      access_code: 1000701,
      selected: true,
    },

    {
      title: '车辆管理',
      name: 'title.vehicleSetting',
      id: 'vehicleSetting',
      isShow: true,
      icon: 'mdi-car',
      access_code: 1000703,
      selected: true,
    },
    {
      title: '设备管理',
      id: 'infoManagement',
      name: 'title.infoManagement',
      icon: 'mdi-information',
      isShow: true,
      access_code: 1000702,
      selected: false,
    },
    {
      title: '驾驶员管理',
      name: 'title.driverManagement',
      id: 'driverManagement',
      isShow: true,
      icon: 'mdi-card-account-details',
      access_code: 1000704,
      selected: true,
    },
    {
      title: '规则管理',
      name: 'title.ruleManagement',
      id: 'ruleManagement',
      isShow: true,
      icon: 'mdi-factory',
      access_code: 1000707,
      selected: true,
    },
    {
      title: '设备升级',
      name: 'title.otaManage',
      id: 'otaManage',
      isShow: true,
      icon: 'mdi-arrow-up-bold-circle',
      access_code: 1000706,
      selected: true,
    },
  ],
}

const mutations = {
  RESET_STATE(state1) {
    state1.meunSettingData = state.meunSettingDefault
    state1.mapSettingData = state.mapSettingDefault
    state1.generalSettingData = state.generalSettingDefaultData
    state1.MGSettingData = state.MGSettingDefault
    state1.videoSettingData = state.videoSettingDefault
    state1.styleSettingData = state.styleSettingDefault
    // state.bigScreenLock = state.BIG_SCREEN_SETTING;
    state1.realtimeSettingData = state.RealtimeSettingDefault
    state1.handlerSettingData = state.handlerSettingDefaultData
    state1.timezoneSettingData = { ...state.timezoneSettingDefault }
  },

  CHANGE_SETTING: (state, { key, value }) => {},
  MEUN_SETTING: (state, data) => {
    state.meunSettingData = data
  },
  MAP_SETTING: (state, data) => {
    state.mapSettingData = data
  },

  HANDLER_SETTING: (state, data) => {
    state.handlerSettingData = data
  },

  GENERAL_SETTING: (state, data) => {
    state.generalSettingData = data
  },
  TIMEZONE_SETTING: (state, data) => {
    state.timezoneSettingData = data
  },
  GM_SETTING: (state, data) => {
    state.MGSettingData = data
  },
  VIDEO_SETTING: (state, data) => {
    state.videoSettingData = data
  },

  STYLE_SETTING: (state, data) => {
    state.styleSettingData = data
  },

  BIG_SCREEN_SETTING: (state, data) => {
    state.bigScreenLock = data
  },

  REALTIME_SETTING: (state, data) => {
    state.realtimeSettingData = data
  },
  // 监控项图标状态改变
  MONITOR_ITEMS_ICONSTAUTS_CHCEK_CHANGE: (state, data) => {
    let { checked, index, disabled } = data
    if (checked != undefined && disabled != undefined) {
      state.monitorItemsIconStautsCheck[index].disabled = disabled
      state.monitorItemsIconStautsCheck[index].checked = checked
    } else if (checked != undefined) {
      state.monitorItemsIconStautsCheck[index].checked = checked
    } else {
      state.monitorItemsIconStautsCheck[index].disabled = disabled
    }
  },

  UPDATE_DEVICE_STATISTICS: (state, stats) => {
    console.log('Updating device statistics:', stats)
    state.deviceStatistics = {
      ...state.deviceStatistics,
      ...stats,
      lastUpdate: new Date().toISOString(),
    }
  },

  SET_DEVICE_LOADING: (state, isLoading) => {
    state.deviceStatistics.isLoading = isLoading
  },
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  resetState({ commit }) {
    commit('RESET_STATE')
  },
  updateDeviceStatistics({ commit }, stats) {
    console.log('Action updateDeviceStatistics called with:', stats)
    commit('UPDATE_DEVICE_STATISTICS', stats)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
